


























































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import MarketingModule from '@/store/modules/Marketing';
import Table from '@/components/Table/Index.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import Pagination from '@/components/Pagination.vue';
import ManageMixin from '@/mixins/Manage.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import AngpowData from '@/data/AngpowData';
import AngpowBody from '@/components/Table/AngpowBody.vue';

@Component({
  components: {
    Table,
    Breadcrumb,
    Pagination,
    AngpowBody,
  },
  mixins: [ManageMixin],
})
export default class Angpow extends Mixins(ManageMixin, ErrorHandleMixin) {
  AuthInstance = getModule(AuthModule, this.$store);

  MarketingInstance = getModule(MarketingModule, this.$store)

  TableHeadMember = [...AngpowData.TableHeadFeature];

  LoginName = '';

  selfFeature = false;

  userId = '';

  _id = '';

  username = '';

  source = this.AuthInstance.user.source;

  searchUsername = '';

  role = 'All';

  startCount = 1;

  PaginationDetail = {
    page: 1,
    amount: 0,
    limit: 100,
  };

  BreadcrumbList: any = [];

  BreadcrumbDefault = [
    {
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
    },
  ];

  AngpowData = {
    _id: '',
    isCloseAngpow: false,
    isCloseLegendOfDolly: false,
    newLobbyFeature: {
      isDrop: true,
      isLevel: true,
      isRank: true,
      isStore: true,
    },
  }

  isOpenModel = false

  isStatusOpenModel = false

  async created() {
    await this.fetchUsers();
  }

  submit() {
    this.PaginationDetail.page = 1;
    this.fetchUsers();
  }

  async handleFeatureMascot(values) {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.MarketingInstance.FeatureAngpowUpdate({
      _id: values._id,
      agent: values.username,
      isCloseLegendOfDolly: this.AngpowData.isCloseLegendOfDolly,
      isCloseAngpow: this.AngpowData.isCloseAngpow,
      angpowFeature: {
        isDrop: this.AngpowData.newLobbyFeature.isDrop,
        isLevel: this.AngpowData.newLobbyFeature.isLevel,
        isRank: this.AngpowData.newLobbyFeature.isRank,
        isStore: this.AngpowData.newLobbyFeature.isStore,
      },
    });
    if (res.code) {
      this.checkError(res);
    }
    this.isOpenModel = false;
    this.GeneralInstance.toggleLoading(false);
    this.fetchUsers();
  }

  async handleFeatureAngpowStatus(values) {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.MarketingInstance.FeatureAngpowUpdate({
      _id: values._id,
      agent: values.username,
      isCloseLegendOfDolly: this.AngpowData.isCloseLegendOfDolly,
      isCloseAngpow: this.AngpowData.isCloseAngpow,
      angpowFeature: {
        isDrop: false,
        isLevel: false,
        isRank: false,
        isStore: false,
      },
    });
    if (res.code) {
      this.checkError(res);
    }
    this.isStatusOpenModel = false;
    this.GeneralInstance.toggleLoading(false);
    this.fetchUsers();
  }

  async fetchUsers() {
    const {
      PaginationDetail: { page, limit },
      searchUsername,
      role,
      username,
      source,
      _id,
    } = this;
    this.GeneralInstance.toggleLoading(true);
    let res;
    if (searchUsername) {
      this.role = 'All';
      res = await this.AccountInstance.FetchDownLineSearch({
        username: searchUsername.trim(),
      });
    } else {
      res = await this.AccountInstance.FetchDownLine({
        pageOption: {
          page,
          limit,
        },
        role,
        username,
        source,
        _id,
        userId: this.AuthInstance.user._id,
        multicurrency: true,
      });
    }
    if (res.code) {
      this.checkError(res);
    } else {
      const { users, pagination, breadcrumb } = this.AccountInstance.users;
      this.userList = users ? [...users] : [];
      this.startCount = pagination ? pagination.startCount : 1;
      this.BreadcrumbList = [...this.BreadcrumbDefault, ...breadcrumb];
      this.PaginationDetail.amount = pagination ? pagination.pageAmount : 0;
    }
    this.GeneralInstance.toggleLoading(false);
  }

  setFeatureAngpow(user) {
    this.isOpenModel = true;
    this.AngpowData = user;
  }

  changeStatusAngpow(user) {
    this.isStatusOpenModel = true;
    this.AngpowData = user;
  }

  changePage(i: number) {
    this.PaginationDetail.page = i;
    this.fetchUsers();
  }

  handleSub(user) {
    this.prepareFetch(user);
  }

  handleBreadcrumb(user) {
    this.prepareFetch(user);
  }

  handleLevel() {
    this.PaginationDetail.page = 1;
    this.fetchUsers();
  }

  prepareFetch(user) {
    this.userId = user._id;
    this._id = user._id;
    this.username = user.username;
    this.source = user.source;
    this.PaginationDetail.page = 1;
    this.searchUsername = '';
    this.fetchUsers();
  }
}
